import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Menu, X, LayoutDashboard, LogOut } from "lucide-react";

import Logo from "./assets/logo.png";

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const navigate = useNavigate();

  return (
    <div className="h-screen flex flex-col bg-white ">
      {/* Header */}
      <header className="h-16 bg-white border-b border-gray-200 px-4 flex items-center justify-between fixed w-full z-10">
        <div className="flex items-center gap-4">
          <button
            onClick={toggleSidebar}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
          >
            {isSidebarOpen ? (
              <X size={24} className="text-gray-700" />
            ) : (
              <Menu size={24} className="text-gray-700" />
            )}
          </button>
          {/* Logo Space */}
          <div className="h-10 w-32 flex items-center">
            <img src={Logo} alt="Logo" className="h-full object-contain" />
          </div>
        </div>

        {/* Logout Button */}
        <button
          className="flex items-center gap-2 px-4 py-2 text-white bg-black hover:bg-gray-800 rounded-lg transition-colors"
          onClick={() => navigate("/")}
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </header>

      <div className="flex h-full pt-16">
        {/* Sidebar */}
        <aside
          style={{ zIndex: "10000px" }}
          className={`fixed left-0 top-16  bg-white border-r border-gray-200 transition-all duration-300 z-50 h-full ${
            isSidebarOpen ? "w-48 md:w-48" : "w-16"
          } ${
            isSidebarOpen
              ? "translate-x-0"
              : "-translate-x-full md:translate-x-0"
          }`}
        >
          <nav className="p-4">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `flex items-center gap-3 p-2 rounded-lg transition-colors ${
                  isActive
                    ? "bg-gray-100 text-black font-medium"
                    : "hover:bg-gray-50 text-gray-700"
                } ${!isSidebarOpen && "md:justify-center"}`
              }
            >
              <LayoutDashboard size={20} />
              {(isSidebarOpen || window.innerWidth < 768) && (
                <span>Dashboard</span>
              )}
            </NavLink>
          </nav>
        </aside>

        {/* Main Content */}
        <main
          className={`flex-1 p-6 transition-all duration-300 ${
            isSidebarOpen ? "ml-0 md:ml-48" : "ml-0 md:ml-16"
          }`}
        >
          <Outlet />
        </main>
      </div>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[5] md:hidden"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default Layout;
